<template>
  <div class="ImageSlider mb-4 mt-2">
    <div v-if="images">
      <div id="SliderCarousel" class="carousel slide carousel-fade" data-bs-ride="carousel">
        <div class="carousel-indicators">
          <button aria-label="بنرها" type="button" data-bs-target="#SliderCarousel" :data-bs-slide-to="index" :class="index === 0 ? 'active' : ''" :key="(image,index)" v-for="(image,index) in images" :aria-current="index === 0 ? 'true' : ''"></button>
        </div>
        <div class="carousel-inner">
          <div class="carousel-item" :class="index === 0 ? 'active' : ''" :key="(image,index)" v-for="(image,index) in images">
            <a :href="image.link">
              <img v-lazy="$MEDIA + image.image" class="d-block w-100 center" :alt="image.alt">
            </a>
          </div>
        </div>
        <button aria-label="قبلی" class="carousel-control-prev" type="button" data-bs-target="#SliderCarousel" data-bs-slide="prev">
          <i class="fa fa-arrow-left color-black" aria-hidden="true"></i>
        </button>
        <button aria-label="بعدی" class="carousel-control-next" type="button" data-bs-target="#SliderCarousel" data-bs-slide="next">
          <i class="fa fa-arrow-right color-black" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="mb-4" v-if="!images">
      <div id="SliderCarousel" class="carousel slide carousel-fade" data-bs-ride="carousel">
        <div class="carousel-inner">
          <div class="carousel-item active">
          <a >
            <img src="../assets/loader.jpg" class="d-block w-100 center">
            </a>
          </div>
        </div>
          <span class="carousel-control-prev">
          <i class="fa fa-arrow-left color-black" aria-hidden="true"></i>
        </span>
        <span class="carousel-control-next">
          <i class="fa fa-arrow-right color-black" aria-hidden="true"></i>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageSlider',
  props: {
    images: Array
  }
}
</script>

<style scoped>
img{
  max-height: 550px;
  border: solid 2px gray;
}
.carousel{
  box-shadow: #afafaf 0px 0px 20px 0px;
  border-radius: 24px;
}
.carousel-indicators {
  top: 0;
}
.carousel-indicators [data-bs-target] {
  background-color: #8b8b8b;
}
.fa{
  font-size: 35px;
}
.carousel-fade .carousel-inner .item {
  opacity: 0;
  -webkit-transition-property: opacity;
  -moz-transition-property: opacity;
  -o-transition-property: opacity;
  transition-property: opacity;
}
.carousel-fade .carousel-inner .active {
  opacity: 1;
}
.carousel-fade .carousel-inner .active.left,
.carousel-fade .carousel-inner .active.right {
  left: 0;
  opacity: 0;
  z-index: 1;
}
.carousel-fade .carousel-inner .next.left,
.carousel-fade .carousel-inner .prev.right {
  opacity: 1;
}
.carousel-fade .carousel-control {
  z-index: 2;
}
.carousel-indicators{
  height: fit-content;
}
</style>
